import React from "react";
import { Input, makeStyles, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
    inputSection: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        position: "relative",
    },
    liveEvaluation: {
        marginTop: "8px",
        padding: "8px 12px",
        borderRadius: "4px",
        textAlign: "center",
        fontSize: "18px",
        fontWeight: "bold",
        minHeight: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    validResult: {
        backgroundColor: tokens.colorPaletteGreenBackground2,
        color: tokens.colorPaletteGreenForeground1,
    },
    invalidResult: {
        backgroundColor: tokens.colorPaletteRedBackground2,
        color: tokens.colorPaletteRedForeground1,
    },
    neutralResult: {
        backgroundColor: tokens.colorNeutralBackground3,
        color: tokens.colorNeutralForeground2,
    },
});

interface ExpressionInputProps {
    expression: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    inputRef: React.RefObject<HTMLInputElement | null>;
    liveResult: {
        value: string;
        valid: boolean;
        isEmpty: boolean;
    };
    showSuccessResult?: boolean;
    isCompleted?: boolean;
}

export function ExpressionInput({
    expression,
    onChange,
    inputRef,
    liveResult,
    showSuccessResult,
    isCompleted,
}: ExpressionInputProps) {
    const styles = useStyles();

    return (
        <div className={styles.inputSection}>
            <Input
                ref={inputRef}
                size="large"
                placeholder="e.g. (2+3+9-4)/1"
                value={expression}
                onChange={onChange}
                readOnly={window.innerWidth <= 768 || isCompleted}
            />
            <div
                className={`${styles.liveEvaluation} ${
                    liveResult.isEmpty
                        ? styles.neutralResult
                        : showSuccessResult
                        ? styles.validResult
                        : styles.invalidResult
                }`}
            >
                {liveResult.isEmpty
                    ? "Type an expression..."
                    : liveResult.value}
            </div>
        </div>
    );
}
